export default "<button pButton label=\"Drop Lead\" class=\"p-button-danger p-button p-mr-3\" (click)=\"dropLead()\" [disabled]=\"!currentLead\"></button>\n";